import React, { useCallback, useMemo } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import { globalStyles, noop } from '@client/shared/constants'

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getMonthList } from '@client/utils';

const ReleaseDateView = ({
  immediateRelease = false,
  releaseDay = '',
  releaseMonth = null,
  releaseYear = '',
  releaseTime = '',
  releaseMeridiem = 'AM',
  timeZone = "",
  handleChange = noop,
}) => {

  const pad = (num, size) => {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  };

  const TIME_LIST = Array.from({ length: 12 })
    .map((item, index) => Array.from({ length: 4 })
    .map((item, i) => `${pad(index === 0 ? 12 : index, 2)}:${pad(i * 15, 2)}`))
    .flat();
  const DAY_LIST = Array.from({ length: 31 }).map((item, index) => `${++index}`);
  const MONTH_LIST = getMonthList() || [];
  const YEARS = Array.from({ length: 3 }).map((item, index) => `${new Date().getFullYear() + index}`);

  const parseTime = (releaseTime) => {
    const [hour, minute] = (releaseTime || "00:00").split(":");
    if (+hour === 0 && releaseTime) {
      releaseTime = `12:${minute}`;
    }
    return releaseTime;
  };
  return (
    <>
      <Box>
        <FormControlLabel
          label={(
            <Typography
              variant="body2"
              sx={{
                ...globalStyles.text.weight.bold,
              }}
            >
              Release Immediately
            </Typography>
          )}
          control={
            <Checkbox
              checked={immediateRelease}
              onChange={evt => {
                const { checked } = evt.target;
                handleChange({
                  name: 'immediateRelease',
                  value: checked
                }, 'checkbox');
              }}
            />
          }
        />
      </Box>
      <Box
        sx={{
          mt: 3
        }}
      >
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            ...globalStyles.text.weight.bold,
            ...(immediateRelease ? globalStyles.text.color.disabled : {})
          }}
        >
          Release Date
        </Typography>
        <Box
          sx={{
            ...globalStyles.display.flex,
          }}
        >
          <Select
            disabled={immediateRelease}
            displayEmpty
            size='small'
            name='releaseDay'
            value={releaseDay}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected = '') => selected.length ? selected : 'Day'}
            sx={{
              mr: 2,
              ...globalStyles.width["15"]
            }}
            onChange={evt => handleChange(evt, 'select')}
          >
            {DAY_LIST.map(day => <MenuItem key={day} value={day}>{day}</MenuItem>)}
          </Select>
          <Select
            disabled={immediateRelease}
            displayEmpty
            placeholder='Month'
            size='small'
            name='releaseMonth'
            value={releaseMonth === null ? '' : MONTH_LIST[+releaseMonth]}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected = '') => selected.length ? selected : 'Month'}
            sx={{
              mr: 2,
              ...globalStyles.width["35"]
            }}
            onChange={evt => handleChange(evt, 'select')}
          >
            {MONTH_LIST.map((month, index) => <MenuItem key={index} value={index}>{month}</MenuItem>)}
          </Select>
          <Select
            disabled={immediateRelease}
            displayEmpty
            size='small'
            name='releaseYear'
            value={releaseYear}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected = '') => selected.length ? selected : 'Year'}
            sx={{
              ...globalStyles.width["25"]
            }}
            onChange={evt => handleChange(evt, 'select')}
          >
            {YEARS.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
          </Select>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 3
        }}
      >
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            ...globalStyles.text.weight.bold,
            ...(immediateRelease ? globalStyles.text.color.disabled : {})
          }}
        >
          Time
        </Typography>
        <Box
          sx={{
            ...globalStyles.display.flex,
            ...globalStyles.flex.align.center,
          }}
        >
          <Select
            disabled={immediateRelease}
            displayEmpty
            size='small'
            name="releaseTime"
            value={parseTime(releaseTime)}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={selected => selected.length ? selected : 'Time'}
            sx={{
              mr: 2,
              ...globalStyles.width["35"]
            }}
            onChange={evt => handleChange(evt, 'select')}
          >
            {TIME_LIST.map((time, index) =>
              <MenuItem key={index} value={time}>
                {time}
              </MenuItem>
            )}
          </Select>
          <Select
            disabled={immediateRelease}
            size='small'
            name="releaseMeridiem"
            value={releaseMeridiem}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
              ...globalStyles.width["15"]
            }}
            onChange={evt => handleChange(evt, 'select')}
          >
            {['PM', 'AM'].map(meridian => <MenuItem key={meridian} value={meridian}>{meridian}</MenuItem>)}
          </Select>
          <Typography
            variant='body1'
            sx={{
              ml: 2,
              ...globalStyles.text.color.disabled
            }}
            >
              Timezone: <b>{timeZone}</b>
            </Typography>
        </Box>
      </Box>
    </>
  )
};

export default ReleaseDateView;